import React from 'react';
import { Card, CardContent, CardHeader, Container, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Container sx={{ minHeight: 'calc(100vh - 292px)', my: 6 }}>
      <Card>
        <CardHeader
          title={<Typography variant="h5">Page Not Found</Typography>}
          subheader="The requested page could not be found."
          sx={{ textAlign: 'center' }}
        />
        <CardContent
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="/assets/notfound.gif" alt="Loading Raccoon" style={{ borderRadius: '20%' }} />
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};

export default NotFound;
